module.exports = __webpack_public_path__ + "img/2-5.6addd4f8.svg";